(ns pfo.task.signature
  (:require [reagent.core :as reagent :refer [atom]]
            [pfo.task.model :as model]
            [pfo.api :as api]
            [pfo.util :as util]
            [pfo.time :refer [now instance-start-time]]
            [cljs-time.core :as time-core :refer [plus minutes before? after?]]))

(def unsign-max-time (minutes 15))

(defn toggle-complete-ability [step step-index first-unsigned-index first-incomplete-index last-complete-index]
  (let [inability-any-of
        [:missing-step-signature-subsequent-locked #(some->> first-unsigned-index (> step-index))

         :all-required-for-cycle-signature #(and (model/is-cycle-signature-step step) (some-> first-incomplete-index (< step-index)))

         :not-a-signer #(and (model/is-any-signature-step step)
                            (not= (:user_id step) (api/get-auth-info :user-id)))

         :locked-by-a-cycle-signature #(and (not (model/is-cycle-signature-step step))
                                           (model/has-cycle-signature step))
         :expired #(let [complete-time (when (:complete step) (util/parse-datetime (:complete_time step)))
                         now-time (now)]
                     (or (and (model/is-any-signature-step step)
                              complete-time
                              (not (before? now-time (plus complete-time unsign-max-time))))
                         (some-> complete-time (after? now-time))))
         :subsequent-complete #(and (:complete step) (model/is-any-signature-step step) (< step-index last-complete-index))]

        [reason unable] (first (filter (fn [[reason is]] (is)) (partition 2 inability-any-of)))]
    (merge (if unable
             {:able false :reason reason}
             {:able true})
           {:step-index step-index
            :first-unsigned-index first-unsigned-index
            :first-incomplete-index first-incomplete-index})))

(defn toggle-complete-able [ability] (:able ability))

(defn toggle-complete-reason [ability]
  (case (:reason ability)
    :missing-step-signature-subsequent-locked (str "Missing step signature at step " (inc (:first-unsigned-index ability)))
    :all-required-for-cycle-signature "Review requires all previous steps to be complete"
    :locked-by-a-cycle-signature "Review has already been made"
    :not-a-signer "Only assigned user can sign"
    :expired "The signature is permanent"
    :subsequent-complete "There's one or more complete steps after this signature"
    nil))
